// carte qui peut s'ouvrir et se fermer, // le libellé sera "Création" ou
"Modification" en fonction de si l'élément passé dans la propriété
creation-modification est défini ou non

<template>
  <span>
    <b-card class="border-light mb-1" no-body>
      <b-card-header class="p-1" header-tag="header">
        <b-btn
          :aria-expanded="isExpanded"
          :class="showCreate ? 'collapsed' : null"
          aria-controls="collapse"
          block
          variant="info"
          @click="showCreate = !showCreate"
        >
          {{ creationModification ? "Modification" : "Création" }}

          <font-awesome-icon v-if="!showCreate" icon="angle-up" />
          <font-awesome-icon v-else icon="angle-down" />
        </b-btn>
      </b-card-header>
      <b-collapse id="collapse" v-model="showCreate">
        <b-card-body>
          <slot />
        </b-card-body>
      </b-collapse>
    </b-card>
  </span>
</template>

<script>
export default {
  name: "CollapseCard",
  props: ["creationModification"],
  data() {
    return {
      showCreate: false,
    };
  },
  computed: {
    isExpanded() {
      if (this.creationModification && this.showCreate === false) {
        this.showCreate = true;
      }
    },
  },
};
</script>
